import { InjectionToken } from '@angular/core';
import {
  SearchEngineConfig,
  DEFAULT_SEARCH_CONFIG,
} from '../models/search-engine-config.model';

export const SEARCH_ENGINE_CONFIG = new InjectionToken<SearchEngineConfig>(
  'SEARCH_ENGINE_CONFIG',
  { providedIn: 'root', factory: () => DEFAULT_SEARCH_CONFIG }
);
